import { useWallet, useWallets } from "@wallet-standard/react";
import { getAddress, AddressPurpose, BitcoinNetworkType } from "sats-connect";
import React, { useContext, useEffect, useState } from "react";
import { ConnectionStatusContext } from "../provider/ConnectionStatusProvider";
import type { Wallet, WalletWithFeatures } from "@wallet-standard/base";
import { useNavigate } from "react-router-dom";
import AlertModal from "../components/modals/AlertModal";

const SatsConnectNamespace = "sats-connect:";

function isSatsConnectCompatibleWallet(wallet: Wallet) {
  return SatsConnectNamespace in wallet.features;
}

const MagicedenWallet: React.FC = () => {
  const [showAlertModal, setShowAlertModal] = useState<any>(false);
  const navigate = useNavigate();
  const connectionStatus = useContext(ConnectionStatusContext);
  const { wallets } = useWallets();
  const { setWallet, wallet } = useWallet();

  async function connectOrDeselect() {
    try {
      await getAddress({
        getProvider: async () =>
          (wallet as unknown as WalletWithFeatures<any>).features[
            SatsConnectNamespace
          ]?.provider,
        payload: {
          purposes: [AddressPurpose.Ordinals, AddressPurpose.Payment],
          message: "Address for receiving Ordinals and payments",
          network: {
            type: BitcoinNetworkType.Mainnet,
          },
        },
        onFinish: (response: any) => {
          console.log("response", response);
          const address = response?.addresses?.find(
            (v: any) => v.purpose === "ordinals"
          )?.address;
          console.log("address", address);

          connectionStatus?.setAccounts(address);

          const balance = {
            confirmed: 0,
            unconfirmed: 0,
            total: 0,
          };
          connectionStatus?.setBalance(balance);
          connectionStatus?.setType("unisat");

          const localStorageItems = {
            accounts: address,
            balance: balance,
            connected: true,
            type: "unisat",
          };

          localStorage.setItem("auth-item", JSON.stringify(localStorageItems));
          setWallet(null);
          navigate("/dashboard");
        },
        onCancel: () => {
          // alert("Request canceled");
          setShowAlertModal(true);
        },
      });
    } catch (err) {
      console.error("Error connecting to wallet:", err);
      setWallet(null);
    }
  }

  useEffect(() => {
    if (wallet && !connectionStatus?.isConnected) {
      connectOrDeselect();
    }
  }, [wallet, connectionStatus]);

  // useEffect(() => {
  //   if (connectionStatus?.isConnected === false) {
  //     setWallet(null);
  //   }
  // }, [connectionStatus, connectionStatus?.isConnected]);

  console.log("wallet", wallet, connectionStatus);

  return (
    <>
      {wallets.filter(isSatsConnectCompatibleWallet).map((wallet, index) => (
        <button
          key={wallet.name}
          type="button"
          onClick={() => setWallet(wallet)}
          className="w-full text-left flex items-center p-3 text-base font-bold text-gray-300 rounded-lg bg-gray-800 hover:bg-gray-600 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
        >
          <img
            className="h-8 w-8 object-contain"
            alt="logo of Magic Eden"
            src="/assets/images/w-icon-3.png"
          />
          <span className="flex-1 ml-3 whitespace-nowrap">Magic Eden</span>
        </button>
      ))}

      {showAlertModal && <AlertModal text="Request canceled" />}
    </>
  );
};

export default MagicedenWallet;
